import { render } from "./ExportedCourses.vue?vue&type=template&id=d1743410&scoped=true"
import script from "./ExportedCourses.vue?vue&type=script&lang=js"
export * from "./ExportedCourses.vue?vue&type=script&lang=js"

import "./ExportedCourses.vue?vue&type=style&index=0&id=d1743410&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1743410"]])

export default __exports__